module.exports = __webpack_public_path__ + "img/7.57676213.png";